module.exports = __webpack_public_path__ + "static/media/bk-home-inactive.49be81cb.png";